import React, { useState } from 'react';

import SvgIcon from "../../SharedComponents/Icons";

import './index.sass';


const Description = ({ description }) => {

  const [isOpen, setIsOpen] = useState(null);

  const descriptionLength = description.length;

  return (
    <div className="description">

      <h2 className="detail-view__section-header">Beskrivelse</h2>

      <div className={`description__wrapper ${descriptionLength > 500 ? 'blurred' : ''} ${isOpen ? 'open' : 'close'}`}>
        <div className="description__text-content" dangerouslySetInnerHTML={{ __html: description }}/>
        <div className="description__blur" />
      </div>

      { descriptionLength > 500 &&
        <div className="description__read-more-button" onClick={() => setIsOpen(!isOpen)}>
          { isOpen ? 'Skjul oplysninger' : 'Læs mere' }
          { isOpen
            ? <SvgIcon name="expand_less" size={24} />
            : <SvgIcon name="expand_more" size={24} />
          }
        </div>
      }
    </div>
  )
}

export default Description;
